
let services = {
    "timebank": {
      id: "timebank",
      primary: 'Time Bank',
      provider: 'Community',
      link:'',
      selected: true,
    },
    "carpooling": {
      id: "carpooling",
      primary: 'Car Pooling',
      provider: 'Community',
      link:'',
      selected: false,
    },
    "secondhand":{
      id: "secondhand",
      primary: 'Second Hand Market',
      provider: 'Community',
      link:'',
      selected: true,
    },
    "help": {
        id: "help",
        primary: 'Help offered/ Required',
        provider: 'Community',
        link:'',
        selected: true,
      },
    };

export default services;